<template lang="pug">
  .classifier.garbage
    e-toolbar(
      :items="items"
      :hideRemoveButton="true"
      :hideAddButton="true"
      :showTotal="true"
      :hideImportBtn="true"
    )
    e-table(
      :items="items"
      :showCheckbox="false"
      :actionColumnWidth="100"
      :showDeleteButton="false"
      :showEditButton="false"
    )
    router-view
</template>

<script>
import { cadastr } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'

export default {
  mixins: [tableMixin],
  methods: {
    getEndpoint(route) {
      return cadastr.garbage(route)
    },
  },
}
</script>
